export default __webpack_public_path__ + "static/media/auth-support-3x.26913554.png";